import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { DishServices } from '../../../dish/services';

/**
 * Generated class for the DishTutorialSlidePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-dish-tutorial-slide',
  templateUrl: 'dish-tutorial-slide.html',
})
export class DishTutorialSlidePage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public dishServices: DishServices) {
  }

  ionViewDidLoad() {
  }

  ionViewDidLeave() {
    this.closeLeave();
  }

  close() {
    this.globals.restaurant.tutorial_dish = true;
    this.dishServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_dish': this.globals.restaurant.tutorial_dish,
    }).then(() => {
      this.navCtrl.pop();
    });

  }

  closeLeave() {
    this.globals.restaurant.tutorial_dish = true;
    this.dishServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_dish': this.globals.restaurant.tutorial_dish,
    }).then(() => {
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/help/tutorial-slider/dish-tutorial-slide/dish-tutorial-slide.ts